"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enableSolanaSnap = void 0;
const utils_1 = require("./utils");
const snap_1 = require("./snap");
const defaultSnapOrigin = 'https://bafybeidttkppmgxhgjnjya6fzzkzlbgkuwcnhjfhnm7jbfhhajda2n424q.ipfs.infura-ipfs.io';
const defaultSnapId = `wallet_plugin_${defaultSnapOrigin}`;
var utils_2 = require("./utils");
Object.defineProperty(exports, "hasMetaMask", { enumerable: true, get: function () { return utils_2.hasMetaMask; } });
Object.defineProperty(exports, "isMetamaskSnapsSupported", { enumerable: true, get: function () { return utils_2.isMetamaskSnapsSupported; } });
/**
 * Install and enable Solana snap
 *
 * Checks for existence of Metamask and version compatibility with snaps before installation.
 *
 * Provided snap configuration must define at least network property so predefined configuration can be selected.
 * All other properties are optional, and if present will overwrite predefined property.
 *
 * @param config - SnapConfig
 * @param pluginOrigin
 *
 * @return MetamaskSolanaSnap - adapter object that exposes snap API
 */
exports.enableSolanaSnap = (config, pluginOrigin) => __awaiter(void 0, void 0, void 0, function* () {
    let snapId = defaultSnapId;
    if (pluginOrigin) {
        snapId = `wallet_plugin_${pluginOrigin}`;
    }
    // check all conditions
    if (!utils_1.hasMetaMask()) {
        throw new Error('Metamask is not installed');
    }
    if (!(yield utils_1.isMetamaskSnapsSupported())) {
        throw new Error("Current Metamask version doesn't support snaps");
    }
    if (!config.network) {
        throw new Error('Configuration must at least define network type');
    }
    // Enable snap
    if (!(yield utils_1.isSnapInstalled(snapId))) {
        yield window.ethereum.send({
            method: 'wallet_enable',
            params: [
                {
                    [snapId]: {},
                },
            ],
        });
    }
    // Create snap describer
    const snap = new snap_1.MetamaskSolanaSnap(pluginOrigin || defaultSnapOrigin);
    // Set initial configuration
    yield (yield snap.getSolanaSnapApi()).configure(config);
    // Return snap object
    return snap;
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEsbUNBQWlGO0FBQ2pGLGlDQUFzRDtBQUd0RCxNQUFNLGlCQUFpQixHQUFHLHlGQUF5RixDQUFDO0FBQ3BILE1BQU0sYUFBYSxHQUFHLGlCQUFpQixpQkFBaUIsRUFBRSxDQUFDO0FBSTNELGlDQUFnRTtBQUF2RCxvR0FBQSxXQUFXLE9BQUE7QUFBRSxpSEFBQSx3QkFBd0IsT0FBQTtBQUU5Qzs7Ozs7Ozs7Ozs7O0dBWUc7QUFDVSxRQUFBLGdCQUFnQixHQUFHLENBQzlCLE1BQTJCLEVBQzNCLFlBQXFCLEVBQ1EsRUFBRTtJQUMvQixJQUFJLE1BQU0sR0FBRyxhQUFhLENBQUM7SUFDM0IsSUFBSSxZQUFZLEVBQUU7UUFDaEIsTUFBTSxHQUFHLGlCQUFpQixZQUFZLEVBQUUsQ0FBQztLQUMxQztJQUVELHVCQUF1QjtJQUN2QixJQUFJLENBQUMsbUJBQVcsRUFBRSxFQUFFO1FBQ2xCLE1BQU0sSUFBSSxLQUFLLENBQUMsMkJBQTJCLENBQUMsQ0FBQztLQUM5QztJQUNELElBQUksQ0FBQyxDQUFDLE1BQU0sZ0NBQXdCLEVBQUUsQ0FBQyxFQUFFO1FBQ3ZDLE1BQU0sSUFBSSxLQUFLLENBQUMsZ0RBQWdELENBQUMsQ0FBQztLQUNuRTtJQUNELElBQUksQ0FBQyxNQUFNLENBQUMsT0FBTyxFQUFFO1FBQ25CLE1BQU0sSUFBSSxLQUFLLENBQUMsaURBQWlELENBQUMsQ0FBQztLQUNwRTtJQUVELGNBQWM7SUFDZCxJQUFJLENBQUMsQ0FBQyxNQUFNLHVCQUFlLENBQUMsTUFBTSxDQUFDLENBQUMsRUFBRTtRQUNwQyxNQUFNLE1BQU0sQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDO1lBQ3pCLE1BQU0sRUFBRSxlQUFlO1lBQ3ZCLE1BQU0sRUFBRTtnQkFDTjtvQkFDRSxDQUFDLE1BQU0sQ0FBQyxFQUFFLEVBQUU7aUJBQ2I7YUFDRjtTQUNGLENBQUMsQ0FBQztLQUNKO0lBRUQsd0JBQXdCO0lBQ3hCLE1BQU0sSUFBSSxHQUFHLElBQUkseUJBQU0sQ0FBQyxZQUFZLElBQUksaUJBQWlCLENBQUMsQ0FBQztJQUMzRCw0QkFBNEI7SUFDNUIsTUFBTSxDQUFDLE1BQU0sSUFBSSxDQUFDLGdCQUFnQixFQUFFLENBQUMsQ0FBQyxTQUFTLENBQUMsTUFBTSxDQUFDLENBQUM7SUFDeEQscUJBQXFCO0lBQ3JCLE9BQU8sSUFBSSxDQUFDO0FBQ2QsQ0FBQyxDQUFBLENBQUMifQ==